/**
 * Created by evgeny on 31.07.2024
 */

const Throwaway = function (unit) {
    UnitComponent.call(this, unit);
    this.unit = unit;

    this.onAnimateDestroy = function () {};
};

Throwaway.prototype = Object.create(UnitComponent.prototype);
Throwaway.prototype.constructor = Throwaway;

Throwaway.prototype.animateDestroy = function (f) {
    this.onAnimateDestroy(() => {
        this.unit.remove();
        f();
    });
};